<template>
  <div id="address">

    <!-- LINE 1 -->
    <v-text-field ref="line1" :validate-on-blur="$refs.line1 && $refs.line1.valid" :rules="rules.line1" v-model.trim="address.line1" label="Line 1" prepend-icon="mdi-map-marker"></v-text-field>
    

    <div class="margin">
      
      <!-- LINE 2 -->
      <v-text-field :validate-on-blur="$refs.line2 && $refs.line2.valid" ref="line2" :rules="rules.line2" v-model.trim="address.line2" label="Line 2"></v-text-field>

      <!-- CITY -->
      <v-text-field ref="city" :validate-on-blur="$refs.city && $refs.city.valid" :rules="rules.city" v-model.trim="address.city" label="City"></v-text-field>

      <!-- PROVINCE -->
      <v-select ref="province" :rules="rules.province" v-model.trim="address.province" label="Province" :items="provinces"></v-select>

      <!-- COUNTRY -->
      <v-select ref="country" :rules="rules.country" label="Country" :items="countries" v-model="address.country"></v-select>

      <!-- POSTAL -->
      <v-text-field ref="postalCode" :mask="maskedPostalCode" :validate-on-blur="$refs.postalCode && $refs.postalCode.valid" :rules="rules.postalCode" label="Postal Code" v-model.trim="address.postal"></v-text-field>
   
    </div>

  </div>
</template>

<script>

  export default {
    data () {
      return {
        address: {
          line1: '',
          line2: '',
          city: '',
          province: '',
          country: 'CA',
          postal: ''
        },
        countries: [
          {
            text: 'Canada',
            value: 'CA'
          }
        ],
        provinces: [
          {
            text: 'Alberta',
            value: 'AB'
          }, {
            text: 'British Columbia',
            value: 'BC'
          }, {
            text: 'Northwest Territories',
            value: 'NT'
          }, {
            text: 'Manitoba',
            value: 'MB'
          }, {
            text: 'New Brunswick',
            value: 'NB'
          }, {
            text: 'Newfoundland',
            value: 'NL'
          }, {
            text: 'Nova Scotia',
            value: 'NS'
          }, {
            text: 'Nunavut',
            value: 'NU'
          }, {
            text: 'Ontario',
            value: 'ON'
          }, {
            text: 'Prince Edward Island',
            value: 'PE'
          }, {
            text: 'Quebec',
            value: 'QC'
          }, {
            text: 'Saskatchewan',
            value: 'SK'
          }, {
            text: 'Yukon',
            value: 'YT'
          }

        ],
        rules: {
          line1: [
            function (e) {
              return !window.regex.title.test(e) ? 'Please enter an address.' : true;
            }
          ],
          line2: [
            
          ],
          city: [
            function (e) {
              return !window.regex.city.test(e) ? 'Please enter a city.' : true;
            }
          ],
          province: [
            function (e) {
              return !window.regex.province.test(e) ? 'Please select a province.' : true;
            }
          ],
          country: [

          ],
          postalCode: [
            function (e) {
              return !window.regex.postal.test(e) ? 'Please enter a valid postal code.' : true;
            }
          ]
        },
        valid: true
      }
    },

    props: {

    },

    methods: {
      
      init (oldAddress) {
        var address = {...oldAddress};
        if (address.country.toLowerCase() === 'canada') address.country = 'CA';
        this.address = address;
      },

      validate () {
        this.$refs.line1.validate(true);
        this.$refs.line2.validate(true);
        this.$refs.city.validate(true);
        this.$refs.province.validate(true);
        this.$refs.country.validate(true);
        this.$refs.postalCode.validate(true);

        this.valid = (this.$refs.line1.valid && this.$refs.line2.valid && this.$refs.city.valid && this.$refs.province.valid && this.$refs.country.valid && this.$refs.postalCode.valid);
      }

    },

    computed: {
  
      maskedPostalCode () {
        if (window.browserDetect.name === 'ie')
          return '';
        else
        return 'A#A #A#';
      }
      
    },

    created () {

    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #address {
    position: relative;

    .margin {
      margin-left: 40px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Address.vue